//VALIDATION SCHEMA FORM
import * as yup from "yup";
import {maxNumberYupLimit} from "../../constants";

export const validationSchema = (t: Function) =>
    yup
        .object()
        .shape({
            type: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            dealer: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable(),
                //.required(t("translation:validation.fieldMandatory")),
            legalEntity: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            description: yup
                .string()
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            recipientLists: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(yup.string().email(t("pricing:alert.errors.email")).nullable()),
            locations: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string(),
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            locationGroups: yup
                .array()
                .min(1, t("translation:validation.fieldMandatory"))
                .of(
                    yup
                        .object()
                        .shape({
                            code: yup.string(),
                            label: yup.string(),
                        })
                        .nullable()
                        .required(t("translation:validation.fieldMandatory"))
                ),
            schedulingType: yup
                .object()
                .shape({
                    code: yup.string(),
                    label: yup.string(),
                })
                .nullable()
                .required(t("translation:validation.fieldMandatory")),
            capacityOfLocations: yup.object().shape({
                remainingCapacityDays: yup
                    .number()
                    .nullable()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.remainingCapacityDays"))
                    .max(365, t("pricing:alert.errors.remainingCapacityDays"))
                    .required(t("translation:validation.fieldMandatory")),
                remainingPercentage: yup
                    .number()
                    .nullable()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .integer(t("pricing:alert.errors.integer"))
                    .min(0, t("pricing:alert.errors.usagePercentage"))
                    .max(100, t("pricing:alert.errors.usagePercentage"))
                    .required(t("translation:validation.fieldMandatory")),
                remainingCapacity: yup
                    .number()
                    .nullable()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .integer(t("pricing:alert.errors.integer"))
                    .min(0, t("pricing:alert.errors.remainingCapacity"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                usagePercentage: yup
                    .number()
                    .nullable()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .integer(t("pricing:alert.errors.integer"))
                    .min(0, t("pricing:alert.errors.usagePercentage"))
                    .max(100, t("pricing:alert.errors.usagePercentage"))
                    .required(t("translation:validation.fieldMandatory")),
            }),
            availabilityOfVehicles: yup.object().shape({
                maxDailyBookings: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                securityMargin: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
            }),
            competitorsBenchmarks: yup.object().shape({
                topPricePosition: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                bottomPricePosition: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
            }),
            rpd: yup.object().shape({
                pickupDateFrom: yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                pickupDateTo: yup
                    .date()
                    .nullable()
                    .min(
                        yup.ref("pickupDateFrom"),
                        t("pricing:rentalPeriods.form.errors.greaterThan")
                    )
                    .required(t("translation:validation.fieldMandatory")),
                minRPD: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
            }),
            pricingErrors: yup.object().shape({
                pickupDateFrom: yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                pickupDateTo: yup
                    .date()
                    .min(
                        yup.ref("pickupDateFrom"),
                        t("pricing:rentalPeriods.form.errors.greaterThan")
                    )
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                minDailyPrice: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                unitType: yup
                    .object()
                    .shape({
                        code: yup.string(),
                        label: yup.string(),
                    })
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
            }),
            advanceBooking: yup.object().shape({
                pickupDateFrom: yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                pickupDateTo: yup
                    .date()
                    .nullable()
                    .min(
                        yup.ref("pickupDateFrom"),
                        t("pricing:rentalPeriods.form.errors.greaterThan")
                    )
                    .required(t("translation:validation.fieldMandatory")),
                pastDays: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                pastOrFutureDays: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(1, t("pricing:alert.errors.atLeastOne"))
                    .max(
                        maxNumberYupLimit,
                        t("pricing:validation.numberLowerThan") + maxNumberYupLimit
                    )
                    .required(t("translation:validation.fieldMandatory")),
                averageBookingsNumber: yup
                    .number()
                    .typeError(t("translation:validation.fieldMandatory"))
                    .nullable()
                    .integer(t("pricing:alert.errors.integer"))
                    .min(0, t("pricing:alert.errors.usagePercentage"))
                    .max(100, t("pricing:alert.errors.usagePercentage"))
                    .required(t("translation:validation.fieldMandatory")),
            }),
            crons: yup.object().shape({
                radioType: yup
                    .string()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                startTime: yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                addTime: yup
                    .date()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
                weeklyDays: yup
                    .array()
                    .min(1, t("translation:validation.fieldMandatory"))
                    .of(
                        yup
                            .object()
                            .shape({
                                code: yup.number(),
                                label: yup.string(),
                            })
                            .nullable()
                            .required(t("translation:validation.fieldMandatory"))
                    ),
                monthlyDays: yup
                    .string()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
            }),
        })
        .defined();
